import './ModuleStatus.css';

import { string } from 'prop-types';
import React from 'react';

const modStatuses = { up: 'работает', down: 'не работает', test: 'тестирование' };

const ModuleStatus = React.memo(({ status }) => (
  <span
    className={`rates-modules-desc-collapse-item-header-module-status rates-modules-desc-collapse-item-header-module-status-${status}`}
  >
    {modStatuses[status]}
  </span>
));

ModuleStatus.propTypes = {
  status: string.isRequired,
};

export default ModuleStatus;
